import { render, staticRenderFns } from "./subjectFormula.vue?vue&type=template&id=1de50b0f&scoped=true&"
import script from "./subjectFormula.vue?vue&type=script&lang=js&"
export * from "./subjectFormula.vue?vue&type=script&lang=js&"
import style0 from "./subjectFormula.vue?vue&type=style&index=0&id=1de50b0f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de50b0f",
  null
  
)

export default component.exports